import React from "react";
import {
    Box,
    Text,
    Heading,
    Textarea,
    Button,
    InputGroup,
    InputRightElement,
} from "@chakra-ui/react";
import { FiSend } from "react-icons/fi";

const ImageReplace: React.FC = () => {
    const [prompt, setPrompt] = React.useState("");

    const handleGenerate = () => {
        if (prompt.trim()) {
            console.log("Generating image with prompt:", prompt);
            // Add your image generation logic here
        }
    };

    return (
        <Box p={10} bg="gray.800" minH="100vh">
            <Heading mb={4} color="teal.300">
                Generate a New Image
            </Heading>
            <Text mb={8} color="gray.300">
                Enter a prompt to create a new AI-generated image that will replace the current image.
                Describe anything you want, and we’ll generate a high-quality replacement for you.
            </Text>
            <Box bg="gray.700" p={6} boxShadow="md">
                <InputGroup size="lg">
                    <Textarea
                        placeholder="Type your prompt here..."
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        resize="none"
                        bg="gray.900"
                        color="white"
                        _placeholder={{ color: "gray.500" }}
                        borderColor="gray.600"
                        borderRight="none"
                        h="150px"
                    />
                    <InputRightElement width="9rem" h="100%">
                        <Button
                            leftIcon={<FiSend />}
                            colorScheme="teal"
                            size="lg"
                            h="100%"
                            width="100%"
                            borderRadius="0"
                            onClick={handleGenerate}
                        >
                            Generate
                        </Button>
                    </InputRightElement>
                </InputGroup>
            </Box>
        </Box>
    );
};

export default ImageReplace;
